import arTranslations from '@/locales/ar.json';
import enTranslations from '@/locales/en.json';
import { Locale } from './config';

type TranslationKeys = typeof arTranslations;

export const translations: Record<Locale, TranslationKeys> = {
  ar: arTranslations,
  en: enTranslations,
};

export function getNestedTranslation(obj: any, path: string): string {
  const keys = path.split('.');
  let value = obj;
  
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      return path; // Return the path if translation not found
    }
  }
  
  return typeof value === 'string' ? value : path;
}

export function translate(key: string, locale: Locale, params?: Record<string, string | number>): string {
  const translation = getNestedTranslation(translations[locale], key);
  
  if (params) {
    return translation.replace(/\{(\w+)\}/g, (match, paramKey) => {
      return params[paramKey]?.toString() || match;
    });
  }
  
  return translation;
}

